<router-outlet></router-outlet>
<script-tag *ngIf="brandService.view === 'fru' && !removeTrackers" src="https://www.googletagmanager.com/gtag/js?id=AW-1040949609"></script-tag>
<script-tag *ngIf="brandService.view === 'mm' && !removeTrackers" src="https://www.googletagmanager.com/gtag/js?id=AW-996288623"></script-tag>
<script-tag *ngIf="!removeTrackers" src="/assets/scripts/form-landing-tracking.js"></script-tag>
<script-tag *ngIf="brandService.trackingSrc && !removeTrackers" src="{{brandService.trackingSrc}}"></script-tag>
